import {css} from "@emotion/css";
import React from "react";
import {GenderDeterminationSelection} from "./UserInformation";
import {convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {UserService} from "../../serverService/userService/UserService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect} from "react";
import {useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMobileInputOutlined, RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function UserBasicInformation({userId, setFullName}) {
    const service = new UserService();
    const loading = new LoadingHelper(useLoadingDispatcher());

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [gender, setGender] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [signupAt, setSignupAt] = useState("");

    useEffect(() => {
        getUserInformationFromServer()
    }, [userId]);

    function getUserInformationFromServer() {
        loading.show()
        service.getUserInformation(userId).then(
            response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setPhoneNumber(response.phoneNumber)
                setNationalCode(response.nationalCode)
                setGender(response.gender)
                setBirthDate(convertUniversalDateToPersianDate(response.birthDate))
                setSignupAt(convertUniversalDateTimeToPersianDateTime(response.signupAt))

                if (response.firstName && response.lastName)
                    setFullName(`${response.firstName} ${response.lastName}`)
                else
                    setFullName(response.phoneNumber)

            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateUserInformation() {
        if (checkAllFields()) {
            loading.show()
            service.updateUserInformation(userId, firstName, lastName, phoneNumber, nationalCode, gender, birthDate).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkAllFields() {
        let state = false
        let message = ""
        if (!firstName || firstName.trim().length === 0) {
            message = "لطفا  نام را وارد نمایید."
        } else if (!lastName || lastName.trim().length === 0) {
            message = "لطفا نام خانوادگی را وارد نمایید."
        } else if (parseInt(nationalCode) === 0) {
            message = "لطفا کد ملی را وارد نمایید."
        } else if (!gender || gender.length === 0) {
            message = "لطفا جنسیت را وارد نمایید."
        } else if (birthDate.length === 0) {
            message = "لطفا تاریخ تولد را وارد نمایید."
        } else
            state = true
        if (message.length > 0)
            showWarningMessage(message)
        return state
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasActionButton
                        actionButtonOnclick={handleUpdateUserInformation}
                    >
                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"نام"}
                                setValue={setFirstName}
                                value={firstName}/>
                            <RaikoSimpleInputOutlined
                                labelText={"نام خانوادگی"}
                                setValue={setLastName}
                                value={lastName}/>
                            <RaikoMobileInputOutlined
                                labelText={"شماره همراه"}
                                setValue={setPhoneNumber}
                                value={phoneNumber}/>
                            <RaikoNumberInputOutlined
                                maxLength={"10"}
                                value={nationalCode}
                                setValue={setNationalCode}
                                labelText={"کد ملی"}
                            />
                            <RaikoCustomSelect
                                labelText={"جنسیت"}
                                setValue={setGender}
                                items={[
                                    raikoCustomSelectItemGenerator(GenderDeterminationSelection.MALE.key, GenderDeterminationSelection.MALE.name),
                                    raikoCustomSelectItemGenerator(GenderDeterminationSelection.FEMALE.key, GenderDeterminationSelection.FEMALE.name),
                                ]}
                                value={gender}
                            />
                            <RaikoSimpleInputOutlined
                                disabled={true}
                                labelText={"تاریخ عضویت"}
                                setValue={setSignupAt}
                                value={signupAt}
                            />
                        </RaikoGridThreeColumn>
                        <RaikoGridOneColumn>
                            <RaikoDatePicker
                                setDate={setBirthDate}
                                date={birthDate}
                                label={"تاریخ تولد"}
                            />

                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}